import { Backdrop, Button, Card, CircularProgress } from "@mui/material";
import PageHeader from "../../common/page-header";
import Create from "./create";
import { useState } from "react";
import { Employee } from "../../../../api/Endpoints/Employee";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import * as React from 'react';

const Directories = () => {

    const columns = [

        { field: 'Title', headerName: 'Title ', width: 300 },
        // { field: 'Description', headerName: 'Description', width: 300 },
        // { field: 'Filesize', headerName: 'File Size', width: 300 },
        // {
        //     field: 'edit',
        //     headerName: 'Edit',

        //     width: 160,
        //     renderCell: (params) => (
        //         <>
        //         <Button varient='contained' size='small' onClick={()=>handleEdit(params.id)}>Edit</Button>
        //         </>
        //     )
        // },

    ];
    const rows = [
        { id: 1,Title: 'Sample' },

    ];


    const [refresh, setRefresh] = useState(false)
    const [editId, setEditId] = useState()
    const [pageNumber, setPageNumber] = useState(0);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showCreateDocument, setCreateDocument] = useState(false)
    const handleCreate = () => {
        setEditId(0)
        setRefresh(Math.random)
    }
    const handleUpdate = () => {
        setPageNumber();
        setPageNumber(0);
    }

    const handlePageChange = (page) => {
        setPageNumber(page)
    }
    const handleEdit = (id) => 
    { setRefresh(Math.random); 
        setEditId(parseInt(id)); }

    useEffect(() => {
        fetchTable();
    }, [pageNumber])




    const fetchTable = () => {
        setLoading(true);
        Employee.get({ page: Number(pageNumber) + 1 }).then(response => {
            setList(response.data.data);
            setLoading(false);
        })
    }


    return (
        <>
            {showCreateDocument ? (
                <Create />

            ) : (


                <>
                    <Card sx={{ p: 1, display: "flex", justifyContent: "space-between", mb: 1, mt: 1, boxShadow: 0, backgroundColor: 'transparent' }} >
                        <PageHeader title={"Directories"} />
                        {/* <Create key={refresh} onNew={handleCreate} onUpdate={handleUpdate} editId={editId} setEditId={setEditId} /> */}

                    </Card >
                    <Card sx={{ m: 2 }} variant="outlined">
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={loading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        {typeof list.data === "object" &&
                            <DataGrid
                                paginationMode="server"
                                rows={rows}
                                columns={columns}
                                page={pageNumber}
                                pageSize={10}
                                rowHeight={20}
                                rowsPerPageOptions={[10]}
                                rowCount={list.total}
                                onPageChange={handlePageChange}
                                autoHeight
                                density={"comfortable"}
                            />
                        }

                    </Card>
                </>
            )
            }

        </>

    )
};

export default Directories;
